import { useRef, useEffect, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import attachIcon from '../../assets/logos/Attach.svg';
import {servUploadFileToS3} from '../../services/ide-apis';
import { global_var } from "../../services/cs-lab-config";

const TinyMCEEditor = ({ onEditorChange, initialValue ,showAttachButton = false  }) => {
  
  const editorRef = useRef(null);
  const placeholder = 'Type the question here..'

  useEffect(() => {
    if (editorRef.current) {
      const currentContent = editorRef.current.getContent();
      if (currentContent !== initialValue) {
        editorRef.current.setContent(initialValue || '');
      }
    }
  }, [initialValue]);
  const [loading, setLoading] = useState(false); 
  const handleEditorChange = (content) => {
    onEditorChange(content);
  };

  const init = {
    placeholder,
    plugins: [
              'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime','table', 'wordcount','emoticons','codesample'
              ],
    toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
    branding: false,
    promotion: false,
    elementpath: false,
    /** ⭐ ADD CUSTOM BUTTON (INSIDE EDITOR) ⭐ */
    setup: (editor) => {
      editor.on('init', () => {
        if (!showAttachButton) return;
        const editArea = editor.getContainer().querySelector('.tox-edit-area');

        if (!editArea) return;

        editArea.style.position = 'relative';

        const attachBtn = document.createElement('button');
        attachBtn.setAttribute('type', 'button');
        attachBtn.className = 'tiny-attach-btn';

        const iconImg = document.createElement('img');
        iconImg.src = attachIcon ;
        iconImg.alt = 'attach icon';
        iconImg.style.width = '16px';
        iconImg.style.height = '16px';
    
        // TEXT
        const textSpan = document.createElement('span');
        textSpan.innerText = 'Attach Files';
    
        // APPEND ICON + TEXT INSIDE BUTTON
        attachBtn.appendChild(textSpan);
        attachBtn.appendChild(iconImg);

        const input = document.createElement('input');
        input.type = 'file';
        input.style.display = 'none';

        input.addEventListener('change', async (e) => {
          const file = e.target.files[0];
          if (!file) return;
          setLoading(true);

          try {
            // Determine folder based on file type
            let folderName = '';
            if (file.type.startsWith('image/')) folderName = 'labQuestionImages';
            else if (file.type.startsWith('video/')) folderName = 'labQuestionVideo';
            else if (file.type.startsWith('audio/')) folderName = 'labQuestionAudio';
            else folderName = 'labQuestionFiles';

            // Upload to S3
            const response = await servUploadFileToS3(file, folderName);

            if (response.status === 'uploaded') {
              const fileKey = response.fileKey;
              const fullUrl = `${global_var.CLOUD_ASSET_STORAGE_URL}/${fileKey}`;

              // Insert into editor
              if (file.type.startsWith('image/')) {
                editor.insertContent(`<img src="${fullUrl}" style="max-width:100%;" />`);
              } else {
                editor.insertContent(`<a href="${fullUrl}" target="_blank">${file.name}</a>`);
              }
            } else {
              console.error('Upload failed:', response);
            }
          } catch (err) {
            console.error('Error uploading file:', err);
          } finally {
            setLoading(false);
            input.value = ''; // reset input
          }
        });


        attachBtn.onclick = () => input.click();

        editArea.appendChild(input);
        editArea.appendChild(attachBtn);
      });
    },        
  };

  return (
    <>
      <Editor
        initialValue={initialValue}
        init={init}
        onEditorChange={handleEditorChange}
        onInit={(evt, editor) => (editorRef.current = editor)}
      />
      {loading && <div style={{ color: '#E96358', marginTop: 4 }}>Uploading file...</div>}
    </>
  );
};
export default TinyMCEEditor;

